// What the CVE table of the dashboard shows about each program: whether it is in the software policy, worked out from the API's coverage (one entry for each
// open CVE finding: the machine, the key a rule would name the program by and what the rule that applies says, null when none does).

const list = (v) => (Array.isArray(v) ? v : []);
const RULE_WORDS = { install: 'Install', update: 'Update', remove: 'Remove', report: 'Report only' };

// { state, rule, key, total, covered, open } for the entries of one program: state is 'in' (every machine has a rule), 'partly', 'not' (none has) or
// 'unnamed' (the program cannot be named in a rule: no definition, winget id or exact catalog name). rule is the word when every covered machine has the
// same one, 'Mixed' otherwise. open: the machines with no rule yet.
export const policyOf = (entries) => {
  const rows = list(entries);
  const key = (rows.find((e) => e.key) || {}).key || null;
  if (!key) return { state: 'unnamed', rule: '', key: null, total: rows.length, covered: 0, open: [] };
  const covered = rows.filter((e) => e.rule);
  const rules = [...new Set(covered.map((e) => e.rule))];
  const state = covered.length === 0 ? 'not' : covered.length === rows.length ? 'in' : 'partly';
  return {
    state, key, total: rows.length, covered: covered.length, open: rows.filter((e) => !e.rule).map((e) => e.device),
    rule: rules.length === 0 ? '' : rules.length === 1 ? RULE_WORDS[rules[0]] || rules[0] : 'Mixed',
  };
};

// The words in the table.
export const policyText = (policy) => {
  if (!policy) return '';
  if (policy.state === 'unnamed') return 'Cannot be named in a policy';
  if (policy.state === 'not') return 'Not in policy';
  if (policy.state === 'in') return `In policy: ${policy.rule}`;
  return `Partly: ${policy.covered} of ${policy.total}`;
};

// The summary rows with the policy of each program added (policy is null while the coverage is not known, or for All customers).
export const cveRows = (top, coverage) => list(top).map((r) => ({
  ...r,
  policy: coverage ? policyOf(list(coverage).filter((e) => e.subject === r.subject)) : null,
}));
